import React, { useContext, useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from "yup";
import { Button, Form, Input, InputGroup, InputGroupText, Label, Spinner } from 'reactstrap';
import { Link, Navigate } from 'react-router-dom';
import { PostData } from '../../../services/FetchData';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { ProductContext } from '../../../store';
// import { useContext } from 'react';
// import { ProductContext } from '../../../store';

const Login = (props) => {
	const [showPassword, setShowPassword] = useState("");
	const [isLogin, setIsLogin] = useState(false);
	// const navigate = useNavigate();
	const {
		setAdminData,
		setUserData
	}						= useContext(ProductContext)

	useEffect(() => {
		document.title	= "Login | ConversionBox App"
		return () => {
			document.title	= "ConversionBox App"
		}
		
	}, [])

	const userLogin = (values, actions) => {
		// event.preventDefault();		
		PostData( 'ms1', 'api/v1/admin/login', values, false, false).then(result => {
			if (result !== 'Invalid' && result !== undefined) {
				if (result.status === "success") {
					// Persist until logout (not refreshed on page load)
					Cookies.set('_cb_admin_token', result.data.accessToken, { expires: 3650 })
					// Store admin profile in context (for header avatar)
					if (result.data.admin) {
						setAdminData(result.data.admin)
						setUserData({
							...result.data.admin,
							userId: result.data.admin?.adminId ?? 1,
						})
					}
					setIsLogin(true)
				} else if( result.status === "failure" ){
					toast.error(result.message)
				} else {
					toast.error(result.message.message)
					
				}
				actions.setSubmitting(false);
			}
		});
	}

	if ( isLogin && Cookies.get('_cb_admin_token')) {
		return <Navigate to="/search/admin-dashboard" replace />
	}

	return (
		<>
			<div className='authFormWrapper'>
				<div>
					<Formik
						initialValues={{ email: "", password: "" }}
						onSubmit={(values, actions) => {
							userLogin(values, actions)
						}}
						validationSchema={Yup.object().shape({
							email: Yup.string().required("Email Required").email("Please enter a valid email address"),
							password: Yup.string().required("Password Required").min(8, "Password is Too short min 8 char")
						})}
					>
						{props => {
							const {
								values,
								touched,
								errors,
								isSubmitting,
								//setSubmitting,
								handleChange,
								handleBlur,
								handleSubmit
							} = props;
							return (
								<Form role="form" onSubmit={handleSubmit} noValidate>
									<div className={`position-relative ${(errors.email && touched.email && "error_field")}`}>
										<Label className="input-group-alternative-label" >
											Email address
										</Label>
										<InputGroup className="input-group-alternative">
											{/* <InputGroupText>
												<span className="material-icons-outlined">mail</span>
											</InputGroupText> */}
											<Input
												placeholder="Email"
												type="email"
												name="email"
												value={values.email}
												onChange={handleChange}
												onBlur={handleBlur}
												autofill='false'
												className={
													"col" || (errors.email && touched.email && "error")
												}
											/>
										</InputGroup>
										{errors.email && touched.email && (
											<div className="input-feedback">{errors.email}</div>
										)}
									</div>
									<div className={`position-relative passwordField ${(errors.password && touched.password && "error_field")}`}>
										<Label className="input-group-alternative-label" >
											Password
										</Label>
										<InputGroup className="input-group-alternative">
											{/* <InputGroupText>
												<span className="material-icons-outlined">lock_open</span>
											</InputGroupText> */}
											<Input
												placeholder="Password"
												type={showPassword ? "text" : "password"}
												name="password"
												value={values.password}
												onChange={handleChange}
												onBlur={handleBlur}
												className={
													"col" ||
													(errors.password && touched.password && "error")
												}
												autofill="false"
											/>
											<InputGroupText>
												<div className="showPasswordWrapper" onClick={() => setShowPassword(!showPassword)}>
													{showPassword ?	
														<span className="material-icons-outlined">visibility</span>
													:
														<span className="material-icons-outlined">visibility_off</span>
													}
														
												</div>
											</InputGroupText>
										</InputGroup>
										{errors.password && touched.password && (
											<div className="input-feedback">{errors.password}</div>
										)}
									</div>
									<div className="d-flex justify-content-center">
										{isSubmitting ? (
											<Button className="cta authCta" color="primary" type="button" disabled>
												<Spinner
													className="white mr-1"
													size="sm"
													color="light"
												/>
												<span className="ml-2 d-inline-block">Loading</span>
											</Button>
										) : (
											<Button className=" cta authCta " color="primary" type="submit">Sign in</Button>
										)}											
									</div>												
								</Form>)
						}}
					</Formik>
				</div>
			</div>
		</>
	);
}
export default Login;